export const SUPABASE_CONFIG = {
  url: import.meta.env.VITE_SUPABASE_URL,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
};

export const STRIPE_CONFIG = {
  publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  apiVersion: '2023-10-16' as const,
};

const STRIPE_PLACEHOLDERS = new Set([
  '',
  'your_stripe_publishable_key_here',
  'pk_test_your_key_here',
]);

export function isStripeConfigured(): boolean {
  const key = (STRIPE_CONFIG.publishableKey || '').trim();
  return key.startsWith('pk_') && !STRIPE_PLACEHOLDERS.has(key);
}
